<template>
  <div>
    <b-button
      v-if="existClient"
      @click="openClientInfoModal"
      size="sm"
      variant="info">
      Профиль
    </b-button>
    <b-button
      v-else-if="clientSetted"
      @click="createClientProfile"
      size="sm"
      variant="success">
      Создать профиль
    </b-button>
    <create-client-profile ref="create-client"></create-client-profile>
    <client-card @update:client-order="$emit('update:client-order', $event)" v-bind="clientIdent" ref="clientCard"></client-card>
  </div>
</template>

<script>
import ClientCard from '../modals/ClientCard'
import {callCenterGetters} from '../../constants/vuexGetters'
import CreateClientProfile from '../modals/CreateClientProfile'
export default {
  name: 'OrderInfoWithOpenButton',
  props: {
    clientIdent: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      vuexNamespace: 'callCenter'
    }
  },
  methods: {
    openClientInfoModal () {
      this.$refs.clientCard.showModalClientCard()
    },
    createClientProfile () {
      this.$refs['create-client'].openModal()
    }
  },
  computed: {
    existClient () {
      return Boolean(this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.CLIENT_CURRENT_ORDER}`])
    },
    clientSetted () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.CLIENT_SETTED}`]
    }
  },
  components: {
    CreateClientProfile,
    ClientCard
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/containers/ClientInfoWithOpenButton.vue